<app-header></app-header>
<ng-container>
  <app-big-banner ></app-big-banner>
</ng-container>

<div class="wrapper-site">
  <router-outlet></router-outlet>
</div>
<!--<app-emergencia *ngIf="router.url === '/home'"></app-emergencia>
<app-boleta *ngIf="router.url !== '/home'" style="display: none;"></app-boleta>
-->
<app-emergencia *ngIf="router.url === '/home'"></app-emergencia>
<app-emergencia *ngIf="router.url === '/beneficio-covid19'" style="display: none;"></app-emergencia>
<app-boleta *ngIf="router.url !== '/home' && router.url !== '/beneficio-covid19'" style="display: none;"></app-boleta>
<app-footer></app-footer>
